import React, { useEffect, useRef, useState } from 'react';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';


import './index.module.less';

const DeviceAuthorizationApply = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [userInfo, setUserInfo] = useState(null);
  const [schoolInfo, setSchoolInfo] = useState(null);
  const getSchoolDetail = async () => {
    const { data } = await Http.post(Api.GetYunbanUnitInfo, { unitUid: params.current.schoolUid });
    setSchoolInfo(data);
  }

  const getUserDetail = async() => {
    const { data } = await Http.post(Api.GetUserDetailInfo, { userUid: params.current.studentUid });
    setUserInfo(data);
  }
  useEffect(() => {
    getSchoolDetail();
    if(params.current.studentUid) {
      getUserDetail();
    }
  }, [])

  const getDateStr = () => {
    let date = '';
    let time = null;
    if(params.current.ts) {
      time = new Date(Number(params.current.ts));
    }else {
      time = new Date();
    }
    date = time.getFullYear() + '年' + (time.getMonth() + 1) + '月' + time.getDate() + '日';
    return date;
  }


  return (
    <div styleName="content">
      <h1><strong>学校个人信息授权使用声明</strong></h1>
      <p style={{ textIndent: '0'}} styleName="text-weight"> 尊敬的家长：</p>
      <p styleName="text-weight">感谢您对学校教学管理工作的支持！</p>
      <p styleName="text-weight">基于我方统一使用希沃学生证设备进行学生管理，为实现学校对学生的教学管理及安全保护目的，我方需要获取您授权提供的您孩子使用的希沃学生证设备信息及其使用过程中所收集、处理的位置信息及运动信息。</p>
      <p styleName="text-weight">在您点击同意《个人信息授权同意书》前，请您仔细阅读本声明，您点击同意《个人信息授权同意书》则表明已知悉并接受本声明所有条款，我方受本声明所有条款约束。</p>


      <p styleName="text-weight">一、除法律法规另有约定外，未经您的同意，我方承诺不会将您授权范围内的信息用于《个人信息授权同意书》授权范围之外的其他用途；或者将您授权范围内的信息提供给与《个人信息授权同意书》约定用途无关的任何第三方；我方承诺通过您授权获取的信息将仅为完成《个人信息授权同意书》中所说明的目的而使用，不将相关信息用于其他任何场合及交易，也不以任何其他方式滥用相关信息。</p>
      <p styleName="text-weight">二、我方将履行数据安全管理职责，建立数据利用安全管理制度，制定数据利用安全保障措施；严格按照数据利用安全管理的相关制度、系统安全保障要求进行使用。在现有技术水平下采取合理必要的措施来保护您授权提供的信息，并通过物理、技术和行政管理安全措施来降低丢失、误用、非授权访问、披露和更改个人信息的风险，包括但不限于传输层数据加密、防火墙加密存储、物理访问控制以及信息访问授权控制等，并要求可能接触到您及您孩子个人信息的所有人员履行相应的保密义务。</p>

      <p>三、我方承诺对您授权提供的信息的处理与使用完全遵守有关法律、法规和规章的规定，不用于任何可能危害国家安全和社会公共利益、侵犯商业秘密和个人隐私或其他不正当的用途，否则由此产生的法律责任由我方承担。</p>
      <p styleName="text-weight">四、因我方违反法律法规或者违反《个人信息授权同意书》约定，造成您或您孩子的合法权益受到损害的，我方将按照您或您孩子因此受到的损失或者我方因此获得的利益向您承担赔偿责任；如您或您孩子因此受到的损失或我方因此获得的利益难以确定，则由人民法院根据实际情况确定赔偿数额；由于不可抗力的原因所导致您的损失，我方将不承担责任。</p>
      <p>五、本声明的解释及争议解决均适用中华人民共和国大陆地区现行法律，如本声明部分条款与适用法律相抵触，则该部分条款将完全按适用法律规定重新解释。</p>
      <p styleName="text-align text-weight">{ schoolInfo?.unitName  } 联系方式：{ schoolInfo?.superAdminPhone }</p>
      <p styleName="text-align text-weight">{ getDateStr() }</p>
      <br />
      <h1><strong>个人信息授权同意书</strong></h1>
      <p style={{ textIndent: '0'}} styleName="text-weight"> 【重要提示】</p>
      <p styleName="text-weight">尊敬的家长，为保障您和您孩子的合法权益，在您点击同意本授权同意书之前，请您审慎阅读<a href="https://account.seewo.com/seewo-account/agreement?appCode=seewo-yunban-mobile&type=0&index=0" styleName="link">《希沃魔方隐私和个人信息保护政策》</a><a href="https://account.seewo.com/seewo-account/agreement?appCode=seewo-yunban-mobile&type=1&index=5" styleName="link">《希沃魔方儿童个人信息保护规则》</a>《学校个人信息授权使用声明》及本授权同意书，并充分理解前述文件的所有条款内容，特别是免除或减轻我们责任或限制您权利的条款。如您不同意的，请点击拒绝并停止下一步操作。如您有任何疑问，可随时通过希沃魔方的客服联系方式向我们进行咨询，我们将为您进一步解释说明相关内容。</p>
      <p styleName="text-weight">您点击同意本授权同意书，则表明您已阅读并充分理解《希沃魔方隐私和个人信息保护政策》《希沃魔方儿童个人信息保护规则》《学校个人信息授权使用声明》及本授权同意书的全部条款，知悉并授权同意我们按照本授权同意书条款内容向申请人提供相关信息。</p>
      <p>本人现授权广州视睿电子科技有限公司（以下简称“广州视睿”）向<span styleName="text-weight">{ schoolInfo?.unitName }</span>（以下简称“申请人”）提供本人孩子<span styleName="text-weight">{ userInfo?.realName || '' }</span>在使用希沃学生证设备过程中，广州视睿采用各种技术所获取的相关信息同步至申请人使用的希沃魔方云系统后台（以下称“系统后台”），以实现学校对学生的教学管理与安全保障目的。</p>
      <p>一、本人已确认知悉，并授权同意广州视睿向申请人提供的信息包括：</p>
      <p>1.本人孩子使用的<span styleName="text-weight">希沃学生证设备信息</span>，包括<span styleName="text-weight">设备ID号码、设备状态信息；</span></p>
      <p>2.希沃学生证设备采用各种技术所获取的本人孩子的<span styleName="text-weight">位置信息</span>，包括<span styleName="text-weight">动态位置信息、精准定位信息、行踪轨迹信息；</span></p>
      <p>3.希沃学生证设备采用各种技术所获取的本人孩子的<span styleName="text-weight">运动信息</span>，包括<span styleName="text-weight">步数、步频、运动距离、运动速度、运动时间信息。</span></p>
      <p>二、本人已确认知悉，并授权同意申请人对以上信息的使用范围包括</p>
      <p>1.在申请人系统后台获取并访问查看本人孩子使用的<span styleName="text-weight">希沃学生证设备信息（包括设备ID号码、设备状态信息）</span>，并与申请人已收集的孩子的姓名、年级、班级信息进行关联匹配、对比核验；</p>
      <p>2.在申请人系统后台获取并访问查看本人孩子的<span styleName="text-weight">位置信息（包括动态位置信息、精准定位信息、行踪轨迹信息）</span>，以确认孩子的位置及活动轨迹信息；</p>
      <p>3.在申请人系统后台获取并访问查看本人孩子的<span styleName="text-weight">运动信息（包括步数、步频、运动距离、运动速度、运动时间信息）</span>，以确认孩子的运动状态信息，开展素质教育工作；</p>
      <p>4.在申请人系统后台，<span styleName="text-weight">将本人孩子使用的希沃学生证设备设置为“免打扰”模式，以在设定的时间或设定的位置阻止来电与通知</span>，以实现孩子的正常上课与学校的教学工作顺利进行。</p>
      <p>三、本人知悉并确认：</p>
      <p styleName="text-weight">1.申请人申请获取并使用上述信息仅系为了实现学校对学生的教学管理及安全保护目的，且仅可基于前述目的使用本人授权范围内的信息。</p>
      <p styleName="text-weight">2.14周岁以下（含）儿童的个人信息以及个人的精准定位信息、行踪轨迹信息等均属于敏感个人信息，一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇。</p>
      <p styleName="text-weight">3.在使用本人授权范围内的信息时，申请人会采取必要措施保障信息安全，防止相关信息非法泄露或不当使用。</p>
      <p styleName="text-weight">4.如本授权同意书所涉及的内容未发生重大修改，则本人的授权同意将被视为长期有效，广州视睿向申请人多次或重复传输本人授权范围内的信息的行为无需重新征求本人的授权同意。</p>
      <p styleName="text-weight">5.本人可以随时通过【希沃魔方app-我的-我的设备-设备信息-对学校授权】、联系客服等方式撤销本人的授权同意。当本人撤销授权同意后，广州视睿将不再向申请人提供相关个人信息，但不会影响此前基于本人的授权同意而开展的个人信息处理活动。</p>
      <p>6.在本人向广州视睿申请撤回同意后，视为停止授权广州视睿向申请人提供前述授权范围内的信息。</p>
      <p>四、本授权同意书有效期自本人点击同意本授权同意书之日起，至本人撤销授权同意之日止。</p>
      <p styleName="text-weight">授权人声明：</p>
      <p styleName="text-weight">在点击同意本授权同意书之前，本人已经认真阅读，知悉并接受<a href="https://account.seewo.com/seewo-account/agreement?appCode=seewo-yunban-mobile&type=1&index=5" styleName="link">《希沃魔方儿童个人信息保护规则》</a>《授权使用声明》的所有条款。</p>
      <p styleName="text-weight">本人已充分理解并同意本授权同意书的全部内容。</p>
      <p styleName="text-weight">特此授权！</p>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      <p></p>

    </div>
  )
}

export default DeviceAuthorizationApply;